// extracted by mini-css-extract-plugin
export default {"title":"StoreClsuterPage_title__9Svcu","title__buttons":"StoreClsuterPage_title__buttons__DuNOK"};